import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import { useSearchParams } from "react-router-dom";
import { cmmsTheme } from "@setup/theme/cmms-theme";

const StatusList = [
	{ code: "All", status: "All" },
	{ code: "O", status: "Open" },
	{ code: "S", status: "Submitted" },
	{ code: "A", status: "Approved" },
];

type Props = {};

export const StatusFilter = ({}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const statusCode = searchParams.get("status") ?? "";

	const handleFilter = (e: SelectChangeEvent<string>) => {
		searchParams.set("status", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<Box>
			<FormControl variant="outlined" margin="dense" fullWidth>
				<InputLabel id="status-select-label">Status</InputLabel>
				<Select
					labelId="status-select-label"
					id="status-select"
					value={statusCode}
					onChange={handleFilter}
					label="Status"
					style={cmmsTheme.styles.filterSelect}
				>
					{StatusList.map((status) => (
						<MenuItem
							style={{ paddingBottom: 0 }}
							key={`status-${status?.code}`}
							value={status?.code}
						>
							{status?.status}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Box>
	);
};
